<script type="text/ecmascript-6">
    import DesignerQuestionSelectSideGlass from "../DesignerQuestionSelectSideGlass.vue";

    export default {
        mixins: [
            DesignerQuestionSelectSideGlass
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Glass';
                }
            },
            frameCombination: {
                required: true
            },
            sideVariant: {
                required: false,
                default() {
                    return 0;
                }
            },
            securedByDesign: {
                required: true,
            },
            slab: {
              required: true,
            },
            typeRange: {
              required: true,
            },
            help_text: {
                default(){
                    return 'Laminated glass holds together when shattered. Toughened Glass breaks into small blunt pieces when shattered.';
                }
            },
            show_help_text: {
                default(){
                    return false;
                }
            },
            glassDesign: {
                required: true,
            }
        },
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 1;
            },
            url(){
              return '/api/options/' + this.fabricator + '/side-glass?frame_combination=' + this.frameCombination + '&secured_by_design=' + this.securedByDesign + '&side_variant=' + this.sideVariant + '&slab=' + this.slab + '&type_range=' + this.typeRange + '&glass_design=' + this.glassDesign;
            },
            cache_key(){
                return '_' + this.frameCombination + '_' + this.securedByDesign + '_' + this.sideVariant + '_' + this.glassDesign + '_' + this.slab;
            },
            passed_filter(){
                return this.variable_ready(this.frameCombination, this.securedByDesign, this.sideVariant);
            },
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'frameCombination': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'sideVariant': function (val, oldVal) {
                this.update_options();
            },
            'glassDesign': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
